import { Skeleton } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { RouteIcon } from './icons';

/**
 * Skeleton exibido enquanto o `GET /jobs/:id` está em voo na primeira
 * carga da subseção Remuneração (EU-161 FR-081a). Mantém o layout
 * (header + grupos de fields) para evitar shift de paint quando os dados
 * chegam.
 */
export function JobEditCompensationLoadingFallback() {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="jobs" />

      <main className="flex flex-1 flex-col items-center gap-8 bg-card px-4 pt-8 pb-16 md:px-8">
        <div
          aria-busy="true"
          aria-label="Carregando seção de remuneração"
          data-testid="job-edit-compensation-loading"
          className="flex w-full max-w-[630px] flex-col gap-8"
        >
          <header className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="flex size-8 items-center justify-center rounded-md bg-secondary text-secondary-foreground">
                <RouteIcon className="size-4" />
              </div>
              <Skeleton className="h-9 w-64" />
            </div>
            <Skeleton className="h-6 w-32" />
          </header>

          <div className="flex flex-col gap-5">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-32 w-full" />
          </div>
        </div>
      </main>
    </div>
  );
}
